import {
  DefaultActionsErrorView,
  ErrorBoundary,
  LoaderCentered,
} from '@modules/components';
import RemoteAnalytics from '@modules/remotes/analytics';
import { Suspense } from 'react';
import { useMfAnalyticsConfig } from './useMfAnalyticsConfig';

function AdmModuleAnalytics() {
  const config = useMfAnalyticsConfig();

  return (
    <ErrorBoundary fallback={<DefaultActionsErrorView />}>
      <Suspense fallback={<LoaderCentered />}>
        <div
          style={{ display: 'contents' }}
          data-testid="adm.analytics.wrapper"
        >
          <RemoteAnalytics {...config} />
        </div>
      </Suspense>
    </ErrorBoundary>
  );
}

export default AdmModuleAnalytics;
